import styled from 'styled-components';

export const Linee = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background: var(--main-clr-green);
`;